export enum LocationRelatableTypeEnum {
  User = 'App\\Models\\User',
  Company = 'App\\Models\\Company',
  PotentialClient = 'App\\Models\\PotentialClient',
}

export function getLocationRelatableTypeLabel(relatable_type: string | null | undefined): string {
  switch (relatable_type) {
    case LocationRelatableTypeEnum.Company:
      return 'Empresa';
    case LocationRelatableTypeEnum.User:
      return 'Personal';
    case LocationRelatableTypeEnum.PotentialClient:
      return 'Cliente potencial';
    default:
      return 'Genérica';
  }
}
